import './CookieTheme.scss'

import React, {HTMLProps} from 'react'
import {createTheme} from '../../util/createtheme'
import {Link as UtilLink, LinkProps} from '../../util/link'
import {Mod, style} from '../../util/style'
import {Trusted} from '../../util/trusted'

type Div = HTMLProps<HTMLDivElement>

const styles = style('cookietheme', [
	'container',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'p',
	'wysiwyg',
	'buttons',
	'button',
	'link'
])

const Container: React.FC<Div> = ({children, ...props}) => {
	return (
		<div {...props} className={styles.container()}>
			{children}
		</div>
	)
}

type Heading = React.FC<
	HTMLProps<HTMLHeadingElement> & {as?: any; mod?: Mod<HeadingMods>}
>

export type HeadingMods =
	| 'bold'
	| 'green'
	| 'white'
	| 'marked'
	| 'slantleft'
	| 'slantright'

const H1: Heading = ({as: Tag = 'h1', mod, ...props}) => (
	<div className={props.className}>
		<Tag {...props} className={styles.h1().mod(mod)} />
	</div>
)
const H2: Heading = ({as: Tag = 'h2', mod, ...props}) => (
	<div className={props.className}>
		<Tag {...props} className={styles.h2().mod(mod)} />
	</div>
)
const H3: Heading = ({as: Tag = 'h3', mod, ...props}) => (
	<div className={props.className}>
		<Tag {...props} className={styles.h3().mod(mod)} />
	</div>
)
const H4: Heading = ({as: Tag = 'h4', mod, ...props}) => (
	<div className={props.className}>
		<Tag {...props} className={styles.h4().mod(mod)} />
	</div>
)
const H5: Heading = ({as: Tag = 'h5', mod, ...props}) => (
	<div className={props.className}>
		<Tag {...props} className={styles.h5().mod(mod)} />
	</div>
)

const P: React.FC<HTMLProps<HTMLParagraphElement>> = (props) => (
	<p {...props} className={styles.p.mergeProps(props)} />
)

const Wysiwyg: React.FC<{children: string} & any> = (props) => (
	<Trusted {...props} className={styles.wysiwyg.mergeProps(props)} />
)

const Buttons: React.FC<{className?: string}> = ({className, children}) => (
	<div className={styles.buttons().with(className)}>{children}</div>
)

const Button: React.FC<
	LinkProps & {
		className?: string
		mod?: Mod<'outline' | 'white'>
	}
> = ({className, mod, children, ...props}) => {
	return (
		<UtilLink {...props} className={styles.button().with(className).mod(mod)}>
			{children}
		</UtilLink>
	)
}

const Link: React.FC<LinkProps & {className?: string; mod?: Mod<'small'>}> = ({
	className,
	mod,
	children,
	...props
}) => {
	return (
		<UtilLink {...props} className={styles.link().with(className).mod(mod)}>
			{children}
		</UtilLink>
	)
}

export const cookieTheme = {
	Container,
	H1,
	H2,
	H3,
	H4,
	H5,
	P,
	Wysiwyg,
	Buttons,
	Button,
	Link
}

export const CookieTheme = createTheme(cookieTheme)
